module.exports = __webpack_public_path__ + "img/img-3-5.53730fb0.webp";